import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu" }

import ModalLinks from "@/views/partials/ModalLinks.vue";
import { ModalsArr } from "@/utils/ModalsArr";
import { Ref, ref, provide, watch } from "vue";
import { useMenuStore } from "@/stores/root/menu";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeBurgerMenu',
  setup(__props) {

const homeModals = ModalsArr;
const menuStore = useMenuStore();
const isActive: Ref<boolean> = ref(false);

watch(menuStore, (current) => {
  current.isActive ? (isActive.value = true) : (isActive.value = false);
});

function showMenu() {
  menuStore.active();
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(["menutoggle", { menuclose: isActive.value }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showMenu()))
      }, null, 2),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["menu-menu", { hide: !isActive.value }])
      }, [
        _createVNode(_component_router_link, {
          class: "menua",
          to: { name: 'quote' }
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Get a Quote", -1)
          ]))]),
          _: 1
        }),
        _createVNode(ModalLinks, {
          modals: _unref(homeModals),
          title: "home"
        }, null, 8, ["modals"])
      ], 2)
    ])
  ]))
}
}

})